module.exports = __webpack_public_path__ + "img/music-pause.c1b0dd0f.png";